import React from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import Tooltip from './Tooltip'
import IconButton from './IconButton'
import ClipboardWithTrendUpIcon from './ClipboardWithTrendUpIcon'

export default function ClipboardWithTrendUp({
  label,
  handleClick = () => {},
  showLabel,
  disabled = false,
}) {
  const { t } = useTranslation()
  const Root = showLabel ? Box : Tooltip
  return (
    <Root title={label || t('common.form.downloadReport')}>
      <div>
        <IconButton
          onClick={handleClick}
          variant="outlined"
          data-testid="download-report-button"
          disabled={disabled}
        >
          <ClipboardWithTrendUpIcon width={24} height={24} />
          {showLabel && (
            <Typography variant="body2" color="textPrimary">
              {label || t('common.form.downloadReport')}
            </Typography>
          )}
        </IconButton>
      </div>
    </Root>
  )
}

ClipboardWithTrendUp.propTypes = {
  label: T.string,
  handleClick: T.func,
  showLabel: T.bool,
  disabled: T.bool,
}
